<h2 mat-dialog-title class="popup-title"><mat-icon>edit</mat-icon>Rename Scout log</h2>
<div mat-dialog-content class="popup-content">
  <p class="popup-description">Update the sequence name for this manufacturing log.</p>
  <div class="popup-record"><span>Current name</span><strong>{{ initSqNumber }}</strong></div>
  <mat-form-field appearance="outline" subscriptSizing="dynamic"><mat-label>New name</mat-label>
    <input matInput [(ngModel)]="draftName" required>
  </mat-form-field>
</div>
<div mat-dialog-actions class="popup-actions">
  <button mat-stroked-button (click)="onNoClick()">Cancel</button>
  <button mat-flat-button class="popup-primary" [disabled]="!draftName?.trim() || draftName.trim() === initSqNumber" (click)="renameScout(log)">Save name</button>
</div>
